// extracted by mini-css-extract-plugin
module.exports = {"errorBoundaryContainer":"styles_errorBoundaryContainer_1oThVtULsfvEVEWTNVuEeG","criticalIcon":"styles_criticalIcon_Y_e4UKduyfIBc8-i_mQKW"};